import { render } from "./hosterInfo.vue?vue&type=template&id=6a3cb467&ts=true"
import script from "./hosterInfo.vue?vue&type=script&lang=ts"
export * from "./hosterInfo.vue?vue&type=script&lang=ts"

import exportComponent from "/home/jenkins/agent/workspace/IT_CICD/SDK/Prod/Joymeet_frontend/GUI/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__